import React, { useState } from "react";
import {
  BsClipboardData,
  BsBriefcase,
  BsBuildings,
  BsCheckCircle,
  BsPersonPlus,
} from "react-icons/bs";

import { Link } from "react-router-dom";
import "./Masters.css";
import useLocalStorageState from "use-local-storage-state";
import { AuthorizationCard } from "../../../pages/AuthorizationCard";

const masterItems = [

  {
    title: "Lead Source",
    description: "Create multiple enquiry sources...",
    icon: <BsClipboardData />,
    path: "/enquirySource",
  },

  {
    title: "Designation",
    description: "Create employee designations...",
    icon: <BsBriefcase />,
    path: "/designation",
  },
  {
    title: "Department",
    description: "Add departments to your system...",
    icon: <BsBuildings />,
    path: "/department",
  },
  {
    title: "Shift",
    description: "Add additional fields for admission...",
    icon: <BsPersonPlus />,
    path: "/shift",
  },
  {
    title: "Product and Services",
    description: "Create multiple student statuses...",
    icon: <BsCheckCircle />,
    path: "/product",
  },
  {
    title: "Chart Of Accounts",
    description: "Create Chart Of Accounts",
    icon: <BsCheckCircle />,
    path: "/chartOfAccounts",
  },
  {
    title: "Templates",
    description: "Select Templates",
    icon: <BsCheckCircle />,
    path: "/templates",
  },
  {
    title: "Currency ",
    description: "Add Curency ",
    icon: <BsCheckCircle />,
    path: "/currency",
  },
];

export const Master = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [customer, _] = useLocalStorageState('customer')
  const permission = customer.customer_details?.permission;
  const user_type = Number(customer.customer_details?.user_type);
  const settingsPermission = permission?.filter(c => c.module_name === "setting")
  // view permission for master 
  const masterGrant = user_type !== 1 ? Boolean(Number(settingsPermission?.filter(c => c.feature_name === "master")[0]?.view)) : true

  return (
    <div className="container">
      {/* <div className="d-flex flex-column text-start">
        <h2 className="h4 mb-1">Masters</h2>
        <span className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
          You can manage masters/dropdown of all the forms.
        </span>
        <hr
          className=" mb-4"
          style={{ borderTop: "0.5px solid #6c757d", opacity: "0.3", marginTop: "0.7rem" }}
        /> */}
      {/* </div> */}
      <div className="mb-3 d-flex justify-content-between align-items-end">
        <div style={{ lineHeight: "0.8rem" }}>
          <h6
            // className="addEnquiryHead"
            style={{ fontWeight: "500", color: "black", fontSize: "1.0rem" }}
          >
            Masters
          </h6>
          <p className="text-muted mb-0 small" style={{ color: "#c7c7c7" }}>
            Manage your company profile and branding.
          </p>
        </div>
        {/* <Button className="btn btn-default" onClick={() => navigate(-1)}>
                        <BsArrowLeft className="me-1" /> Back
                    </Button> */}
      </div>
      <hr
        className="mt-2 mb-4"
        style={{
          borderTop: "0.5px solid #6c757d",
          opacity: "0.3",
        }}
      />

      <div className="row">
        {
          masterGrant ?
            masterItems.map((item, index) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={index}>
                <Link to={item.path} className="text-decoration-none text-dark">
                  <div
                    className="custom-card p-3 h-100 shadow-sm rounded bg-white d-flex align-items-start tooltip-custom"
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    <div className="icon-box me-3 mt-1">
                      {React.cloneElement(item.icon, {
                        size: 20,
                        color: "#0d6efd",
                      })}
                    </div>

                    <div className="text-box flex-grow-1">
                      <h6 className="fw-semibold mb-1 card-title">{item.title}</h6>
                      <p className="text-muted desc-text mb-0 text-truncate">
                        {item.description}
                      </p>
                    </div>

                    {hoveredIndex === index && (
                      <div className="tooltip-box-master">{item.description}</div>
                    )}
                  </div>
                </Link>
              </div>
            ))
            :
            <AuthorizationCard></AuthorizationCard>
        }
      </div>
    </div>
  );
};
